/* app/js/src/components/monitoring/targets/monitoring-targets.component.scss */
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
.container {
  margin-left: 5%;
  margin-right: 5%;
}
.container .filter {
  flex-basis: 300px;
}
.container .filter icn-dropdown {
  width: 300px;
}
.buttons {
  text-align: right;
}
.inputs-table {
  width: 100%;
  text-align: center;
  color: #232f3a;
}
.inputs-table tr:nth-child(odd) {
  background-color: #fdfdfd;
}
.inputs-table tbody tr:hover {
  background-color: #e7dfdf;
}
.inputs-table th {
  border-bottom: 1px solid #232f3a;
}
.inputs-table th.sort-column {
  cursor: pointer;
  text-decoration: underline;
}
.inputs-table th,
.inputs-table td {
  height: 2vw;
  text-align: left;
}
.inputs-table th > a,
.inputs-table th span,
.inputs-table td > a,
.inputs-table td span {
  color: #40c4ff;
  cursor: pointer;
  text-decoration: none;
}
.inputs-table th > a:hover,
.inputs-table th span:hover,
.inputs-table td > a:hover,
.inputs-table td span:hover {
  text-decoration: underline;
}
.inputs-table th .status,
.inputs-table td .status {
  padding: 5px;
}
.inputs-table th .status.online,
.inputs-table td .status.online {
  background-color: greenyellow;
}
.inputs-table th .status.offline,
.inputs-table td .status.offline {
  background-color: #e87474;
}
.icon-arrow,
.icon-sort-asc,
.icon-sort-desc {
  display: inline-block;
  height: 0;
  width: 0;
  border-style: solid;
  border-color: transparent;
  cursor: pointer;
}
.icon-sort-desc {
  border-width: 12px 7px 0;
  border-top-color: #444444;
}
.icon-sort-asc {
  border-width: 0 7px 12px;
  border-bottom-color: #444444;
}
/*# sourceMappingURL=monitoring-targets.component.css.map */
